export default __webpack_public_path__ + "static/rachel-a2a67cb6751476081247d4ad4129a947.png";